import React, { useContext, useState, useCallback } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { withCookies } from 'react-cookie';

import DataForm from '../../src/components/ticketing/CreateTicket/CreateTicketDataForm';
import RequestForm from '../../src/components/ticketing/CreateTicket/CreateTicketRequestForm';
import OriginForm from '../../src/components/ticketing/CreateTicket/CreateTicketOriginForm';

import IsUserLogged from '../components/IsUserLogged';
import ScrollToTop from '../components/ScrollToTop';
import Globals from '../Globals';

import Traductor from '../components/Traductor';
import { UserContext } from '../contexts/UserContext';
import TicketingService from '../services/TicketingService';
import Loading from '../components/bronson/Loading';

const CreateTicketPage = ({ history, cookies }) => {
    const { user } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const t = new Traductor();
    const [correctForm, setCorrectForm] = useState(true);

    const onSubmitTicket = async (data, bag) => {
        const fields = Object.fromEntries(
            Object.entries(data).filter(([key, value]) => !!value)
        );
        await CreateNewTicket(fields, bag);
    };

    const CreateNewTicket = async (data, bag) => {
        data.IdUser = user?.data?.Empleado?.Id;
        setLoading(true);
        new TicketingService()
            .createTicket(cookies.get(Globals.COOKIES.JWT).AccessToken, data)
            .then(response => {
                var idNewTicket = response.body;
                if (idNewTicket !== null && idNewTicket !== '') {
                    alert(
                        t.getTraduction('TicketMade_title') + ': ' + idNewTicket
                    );
                    bag.resetForm();
                } else {
                    alert(t.getTraduction('TicketMadeError_title'));
                    //Error to Insert
                }
                setLoading(false);
            });
    };
    const validateForm = isValidated => {
        setCorrectForm(isValidated);
    };

    const onClickGoToSearchTicket = () => {
        const route = Globals.APPLICATION_PATH.SEARCH_TICKET;
        if (history.location.pathname !== route) {
            history.push(route);
        }
    };

    const renderError = () => {
        if (correctForm) {
            return '';
        } else {
            return (
                <p className="c-error-message">
                    {t.getTraduction('ErrorViculoPlate')}
                </p>
            );
        }
    };

    return (
        <section className="o-content-section u-pt-small u-rema-full-height">
            <IsUserLogged />
            <ScrollToTop />

            <div className="o-page-wrap o-page-wrap--xsmall">
                {user.data.UserId ? ( //If no user data -> Can't set initial values -> Loading state
                    <Formik
                        initialValues={{
                            IdUser: user.data.Empleado.Id || '',
                            plate: '',
                            orderNumber: '',
                            name: user.data.UserId || '',
                            email: user.data.Email || '',
                            phone: user.data.Phone || '',
                            finalClient: false,
                            ticketDate: new Date(
                                Date.now()
                            ).toLocaleDateString(),
                            ticketType: '',
                            // channelType: "",
                            channelCode: '',
                            shortDescription: '',
                            longDescription: '',
                        }}
                        onSubmit={onSubmitTicket}
                        validationSchema={Yup.object().shape({
                            plate: Yup.string().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                            name: Yup.string(),
                            email: Yup.string(),
                            phone: Yup.number().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                            finalClient: Yup.bool()
                                .nullable()
                                .required(
                                    t.getTraduction('RequiredFieldError')
                                ),
                            date: Yup.string(),
                            ticketType: Yup.string().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                            /* channelType: Yup.string().required(
                  t.getTraduction("RequiredFieldError")
                ),*/
                            channelCode: Yup.string().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                            shortDescription: Yup.string().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                            shortDescription: Yup.string()
                                .required(t.getTraduction('RequiredFieldError'))
                                .max(
                                    100,
                                    t.getTraduction('MaxLengthFieldError') +
                                        ' (100)'
                                ),
                            longDescription: Yup.string().required(
                                t.getTraduction('RequiredFieldError')
                            ),
                        })}
                    >
                        {({
                            values,
                            handleSubmit,
                            setFieldValue,
                            errors,
                            isValid,
                            touched, //display the errors on submit form
                            handleBlur, //handleBlur needs name and value, not using the callback at the moment
                        }) => (
                            <>
                                <fieldset className="o-fieldset">
                                    <legend className="c-form-heading  ">
                                        <div className="o-layout_link_return_ticket u-6/12 u-1/2@m">
                                            <a
                                                href={onClickGoToSearchTicket}
                                                onClick={
                                                    onClickGoToSearchTicket
                                                }
                                                class="c-link  "
                                            >
                                                <i
                                                    class="c-link__icon  c-icon  c-icon--[semantic-back]  "
                                                    aria-hidden="true"
                                                    role="img"
                                                ></i>
                                                <span class="c-link__body  ">
                                                    <span class="c-link__effect">
                                                        {t.getTraduction(
                                                            'Return'
                                                        )}
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                        <strong className="c-form-heading__title">
                                            <span className="c-form-heading__title-text">
                                                <h1>
                                                    {t.getTraduction(
                                                        'CreateTicket'
                                                    )}
                                                </h1>
                                            </span>
                                        </strong>
                                    </legend>
                                </fieldset>
                                <div className="c-form-section-group">
                                    <OriginForm
                                        onChange={setFieldValue}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        onTouch={handleBlur}
                                        cookies={cookies}
                                        validateForm={validateForm}
                                        renderErrorVinculo={renderError}
                                        // validate={TitleError}
                                    />
                                    {renderError()}
                                    <RequestForm
                                        onChange={setFieldValue}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        onTouch={handleBlur}
                                    />
                                    <DataForm
                                        onChange={setFieldValue}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        onTouch={handleBlur}
                                        cookies={cookies}
                                        userData={user}
                                    />
                                    {renderError()}
                                    <Loading
                                        ariaBusy={loading}
                                        disableIcon={true}
                                    />
                                    <div className="u-text-right">
                                        <button
                                            className="c-btn c-btn--secondary"
                                            onClick={onClickGoToSearchTicket}
                                        >
                                            <span class="c-btn__text">
                                                {t.getTraduction(
                                                    'VolverAlListado'
                                                )}
                                            </span>
                                        </button>
                                        <button
                                            className="c-btn c-btn_create_Ticket"
                                            onClick={handleSubmit}
                                            type="submit"
                                            disabled={!isValid && !correctForm}
                                        >
                                            <span class="c-btn__text">
                                                {t.getTraduction(
                                                    'CreateTicket'
                                                )}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </Formik>
                ) : null}
            </div>
        </section>
    );
};

export default withCookies(CreateTicketPage);
